/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { CONSUMER_SITE_BASE_URL } from '../../../../constants';
import Label from '../../../../fields/normal/GeneralCheckbox/Label';

const LegalCheckboxLabel = () => (
  <Label>
    I agree that James Hardie may collect my personal information in accordance
    with its{' '}
    <a
      href={`${CONSUMER_SITE_BASE_URL}/collection-statement-builder`}
      title="Collection Statement"
      target="_blank"
      rel="noopener noreferrer"
    >
      Collection Statement
    </a>
    ,{' '}
    <a
      href={`${CONSUMER_SITE_BASE_URL}/privacy-policy`}
      title="Privacy Policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>{' '}
    and{' '}
    <a
      href={`${CONSUMER_SITE_BASE_URL}/terms-of-use`}
      title="Terms of Use"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Use
    </a>
    , and provide it to James Hardie customers who may use it to send me
    enquiries.
  </Label>
);

export default LegalCheckboxLabel;
